// src/activities/cape-vr/cape-vr-views/CAPEVRProtocol.jsx

import { Trans, useTranslation } from 'react-i18next';
import { useLanguage } from '../../../locales/LanguageContext';
import CAPEVRCitation from '../../../components/citations/CAPEVRCitation';
import AVIcon from '../../../components/icons/AllVoicedIcons';

function CAPEVRProtocol() {
  const { t } = useTranslation();
  const { appLanguage, resourceLanguages } = useLanguage();
  const availableCAPEVRLanguages = resourceLanguages.CAPEVR || [];
  const isLanguageUnavailable = !availableCAPEVRLanguages.includes(appLanguage);

  const translatedLanguageList = availableCAPEVRLanguages
    .map(code => t(`language_names.${code}`))
    .join(', ');

  return (
    <div className="document-container">
      {/* 🔹 Avís d’idioma */}
      {isLanguageUnavailable && (
        <div className="warning-message">
          <AVIcon icon="info" size={20} color="#209385" />
          <span>{t('resource_available_languages', { languages: translatedLanguageList })}</span>
        </div>
      )}

      {/* 🔹 Contingut principal */}
      <section className="document-text">
        <Trans
          i18nKey="capevr_protocol_whole_text"
          components={{
            h1: <h1 className="document-title">.</h1>,
            h2: <h2 className="document-subtitle">.</h2>,
            h3: <h3 className="document-section-title">.</h3>,
            h4: <h4 className="document-subsection-title">.</h4>,
            p: <p className="document-paragraph" />,
            ul: <ul className="document-list" />,
            li: <li className="document-list-item" />,
            strong: <strong className="document-strong" />,
          }}
        />
      </section>

      {/* 🔹 Cita final */}
      <div className="protocol-citation">
        <CAPEVRCitation />
      </div>
    </div>
  );
}

export default CAPEVRProtocol;
